import * as Sentry from "@sentry/react";

import {
  API_URL,
  ENVIRONMENT,
  GIT_COMMIT,
  SENTRY_DSN,
} from "@/common/utils/env";

if (SENTRY_DSN) {
  let tunnel: string | undefined;

  try {
    const sentryDsn = new URL(SENTRY_DSN);
    const projectId = sentryDsn.pathname.replace(/^\/+|\/+$/g, "");
    if (projectId) {
      tunnel = `${API_URL}/sentry-proxy/api/${projectId}/envelope/`;
    }
  } catch {
    tunnel = undefined;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    tunnel,
    environment: ENVIRONMENT,
    release: GIT_COMMIT,
    sendDefaultPii: false,
    tracesSampleRate: 1.0,
    propagateTraceparent: true,
    // Propagate traces to backend API (cross-origin on localhost)
    tracePropagationTargets: [
      "localhost",
      "reflag.local",
      /^https:\/\/(app|staging\.app)\.reflag\.com/,
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.featureFlagsIntegration(),
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function setSentryUser(attributes: { id: string; email?: string }) {
  Sentry.setUser(attributes);
}
